import type { CartExperimentState } from '@/types/cart-experiment';

/** Header 会跨路由保留；不能仅凭 store 中残留的实验分组切换全站侧栏。 */
export function getCartSidebarPresentation(
  pathname: string,
  isMobile: boolean,
  experiment: CartExperimentState,
): 'legacy' | 'v1' {
  return !isMobile &&
    pathname === '/cart' &&
    experiment.status === 'resolved' &&
    (experiment.value === 3 || experiment.value === 4)
    ? 'v1'
    : 'legacy';
}
